import React, { useState } from 'react';
import { SceneCard } from '../components/SceneCard';
import { CreateSceneModal } from '../components/CreateSceneModal';
import { SceneHistory } from '../components/SceneHistory';
import { PlusIcon, HistoryIcon } from 'lucide-react';
export function SceneController() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [scenes, setScenes] = useState([{
    id: 1,
    name: 'Sleep',
    description: 'Optimize for comfortable sleep',
    devices: ['IR AC Pod', 'Smart Plug - TV', 'Smart Plug - Lights'],
    trigger: 'Time: 10:00 PM daily',
    active: true,
    lastActivated: '2024-01-15 22:00:00',
    actions: [{
      device: 'IR AC Pod',
      action: 'Set temperature to 24°C'
    }, {
      device: 'Smart Plug - TV',
      action: 'Turn off'
    }, {
      device: 'Smart Plug - Lights',
      action: 'Turn off'
    }]
  }, {
    id: 2,
    name: 'Away',
    description: 'Save energy when not at home',
    devices: ['Smart Plug - Kitchen', 'Smart Plug - Living Room'],
    trigger: 'Location: Away from home',
    active: true,
    lastActivated: '2024-01-15 08:30:00',
    actions: [{
      device: 'Smart Plug - Kitchen',
      action: 'Turn off'
    }, {
      device: 'Smart Plug - Living Room',
      action: 'Turn off'
    }]
  }, {
    id: 3,
    name: 'Energy Saving',
    description: 'Reduce energy consumption during peak hours',
    devices: ['IR AC Pod', 'Smart Plug - Kitchen'],
    trigger: 'Time: 12:00 PM - 3:00 PM daily',
    active: false,
    lastActivated: '2024-01-14 12:00:00',
    actions: [{
      device: 'IR AC Pod',
      action: 'Set temperature to 28°C'
    }, {
      device: 'Smart Plug - Kitchen',
      action: 'Turn off'
    }]
  }]);
  const handleCreateScene = newScene => {
    setScenes([...scenes, {
      ...newScene,
      id: scenes.length + 1
    }]);
    setShowCreateModal(false);
  };
  const handleToggleScene = sceneId => {
    setScenes(scenes.map(scene => scene.id === sceneId ? {
      ...scene,
      active: !scene.active
    } : scene));
  };
  const handleDeleteScene = sceneId => {
    setScenes(scenes.filter(scene => scene.id !== sceneId));
  };
  return <div className="p-6 max-w-7xl mx-auto" data-id="element-567">
      <header className="flex justify-between items-center mb-8" data-id="element-568">
        <div data-id="element-569">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-570">
            Scene-Based Controller
          </h1>
          <p className="text-gray-500" data-id="element-571">
            Create and manage automated scenes for your smart home
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-572">
          <button onClick={() => setShowHistory(!showHistory)} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center" data-id="element-573">
            <HistoryIcon size={18} className="mr-2" data-id="element-574" />
            History
          </button>
          <button onClick={() => setShowCreateModal(true)} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center" data-id="element-575">
            <PlusIcon size={18} className="mr-2" data-id="element-576" />
            Create Scene
          </button>
        </div>
      </header>
      {showHistory ? <SceneHistory data-id="element-577" /> : <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-578">
            {scenes.map(scene => <SceneCard key={scene.id} scene={scene} onToggle={handleToggleScene} onDelete={handleDeleteScene} data-id="element-579" />)}
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-580">
            <h2 className="text-lg font-semibold mb-4" data-id="element-581">How Scenes Work</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-582">
              <div className="text-center" data-id="element-583">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-584">
                  <span className="text-green-600 font-bold" data-id="element-585">1</span>
                </div>
                <h3 className="font-medium mb-2" data-id="element-586">Select Devices</h3>
                <p className="text-sm text-gray-600" data-id="element-587">
                  Choose which devices to include in your scene
                </p>
              </div>
              <div className="text-center" data-id="element-588">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-589">
                  <span className="text-green-600 font-bold" data-id="element-590">2</span>
                </div>
                <h3 className="font-medium mb-2" data-id="element-591">Set Actions</h3>
                <p className="text-sm text-gray-600" data-id="element-592">
                  Define what each device should do
                </p>
              </div>
              <div className="text-center" data-id="element-593">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-594">
                  <span className="text-green-600 font-bold" data-id="element-595">3</span>
                </div>
                <h3 className="font-medium mb-2" data-id="element-596">Set Triggers</h3>
                <p className="text-sm text-gray-600" data-id="element-597">
                  Choose when the scene should activate
                </p>
              </div>
            </div>
          </div>
        </>}
      {showCreateModal && <CreateSceneModal onClose={() => setShowCreateModal(false)} onCreate={handleCreateScene} data-id="element-598" />}
    </div>;
}